import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const menuDefaultVariants = {}
const menuCompoundVariants = []

const menuSlotNames = [
  [
    "content",
    "menu__content"
  ],
  [
    "list",
    "menu__list"
  ],
  [
    "item",
    "menu__item"
  ],
  [
    "icon",
    "menu__icon"
  ],
  [
    "label",
    "menu__label"
  ],
  [
    "divider",
    "menu__divider"
  ],
  [
    "group",
    "menu__group"
  ],
  [
    "groupTitle",
    "menu__groupTitle"
  ],
  [
    "itemIndicator",
    "menu__itemIndicator"
  ]
]
const menuSlotFns = /* @__PURE__ */ menuSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, menuDefaultVariants, getSlotCompoundVariant(menuCompoundVariants, slotName))])

const menuFn = memo((props = {}) => {
  return Object.fromEntries(menuSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const menuVariantKeys = []
const getVariantProps = (variants) => ({ ...menuDefaultVariants, ...compact(variants) })

export const menu = /* @__PURE__ */ Object.assign(menuFn, {
  __recipe__: false,
  __name__: 'menu',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: menuVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, menuVariantKeys)
  },
  getVariantProps
})